import { useContext } from "react";
import { FinanceInventoryContextType } from "./finance-inventory-types";
import { FinanceInventoryContext } from "./finance-inventory-context";

export default function useFinanceInventory() {
  const data = useContext<FinanceInventoryContextType | undefined>(FinanceInventoryContext);
  if (data === undefined) {
    throw new Error("useFinanceInventory must be used within a FinanceInventoryContext");
  }

  return data;
}
